export default {
    //语言配置规则：Array index0=简体，index1=繁体，，index2=英文 
    header: {
        home:['首页','首页','Home'],
        games:['游戏','游戏','Games'],
        careers:['加入我们','加入我们','Careers'],
        about:['关于我们','关于我们','about'],
        language:['语言','语言','Language'],
        english:['英语','英语','ENGLISH'],
        zh_hk:['繁体中文','繁体中文','ZH-HK'],
        zh_cn:['简体中文','简体中文','ZH-CN'],
    },
    footer:{
        tel:['电话','电话','Tel'],
        email:['邮箱','邮箱','E-mail'],
        address:['地址','地址','Address'],
        addressInfo:['上海市虹口区西江湾路230号B幢406室','上海市虹口区西江湾路230号B幢406室','上海市虹口区西江湾路230号B幢406室',],
        games:['我们的游戏','我们的游戏','Games'],
        g1:['开心方块','开心方块','Happy Blocks'],
        g2:['数字大师','数字大师','Number Master'],
        g3:['复古蜘蛛纸牌','复古蜘蛛纸牌','Ancient Spider Solitaire',],
        g4:['拼图大师','拼图大师','Daily Jigsaw Puzzles',],
        about:['关于我们','关于我们','About'],
        company:['公司介绍','公司介绍','Company info'],
        contact:['联系我们','联系我们','Contact'],
        careers:['加入我们','加入我们','Careers'],
        clause:['隐私条款','隐私条款','Privacy clause'],
        codeOfUse:['使用守则','使用守则','Code of use'],
    },
    index:{
        bestGameTitle:['做最好的游戏','做最好的游戏','Make Best Games'],
        bestGameInfo:['我们专注于游戏开发及运营多年，用心为玩家度身订造出最好玩的游戏。我们目标不止做A级游戏，而是做出S级精品游戏', '我们专注于游戏开发及运营多年，用心为玩家度身订造出最好玩的游戏。我们目标不止做A级游戏，而是做出S级精品游戏','We focus on game development and operation for many years! We are not only doing A grade games but S grade!'],
        dataTitle:['我们用数据说话','我们用数据说话','About Statistics'],
        userCommentTitle:['来自用户的评价','来自用户的评价','Review from our Gamers'],
        type:['注册玩家','注册玩家','Number of players']

    }


}




// WEBPACK FOOTER //
// ./src/assets/language_package.js